import React, { useState } from 'react';
import { AutoComplete } from 'material-ui';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './HSIdsCodes.scss';
import { useRefState } from 'helpers/react.utils';
import { hsCodeFind } from 'services/hsCodes';

const hsCodesConfig = {
    text: 'text', 
    value: '_id',
};

/**
 * 
 * @param {{ 
 *  cargoIndex: number,
 *  cargoOrder: any, 
 *  changeCargo: Function,
 *  numberOrderTable?: number,}} value
 */
function HSCode({ 
    cargoIndex, cargoOrder, changeCargo,
}) {
    const [hsCodes, setHsCodes] = useState([]);
    const [search, setSearch, searchRef] = useRefState('');

    /**
     * @param {string} e 
     */
    const onChangeAutoCompleteHSCode = async (e) => {
        setSearch(e);

        if (e.trim().length < 3) {
            changeCargo([{
                field: `cargo.${cargoIndex}.hsCodeId`,
                value: { _id: undefined, name: null },
            }]);
            return;
        }

        changeCargo([{
            field: `cargo.${cargoIndex}.hsCodeId`,
            value: { _id: undefined, name: e },
        }]);

        const _hsCodes = await hsCodeFind(e);

        if (searchRef.current !== e) {
            return;
        }

        setHsCodes(_hsCodes);
    };

    const onChooseAutoCompleteHSCode = (value) => {
        changeCargo([{
            field: `cargo.${cargoIndex}.hsCodeId`,
            value,
        }]);
    };

    return (
        <div 
            id='details-for-cargo'
            className='row'
        >
            <div className='column-left'>
                Hs Code:
            </div>
            <div className='column-right' style={{ width: '359px' }}>
                <AutoComplete
                    name='hsCode'
                    textFieldStyle={{ fontSize: '13px' }}
                    hintText='Hs Code'
                    hintStyle={{ fontSize: '13px' }}
                    searchText={
                        search || 
                        (cargoOrder && cargoOrder.cargo[cargoIndex] ? cargoOrder.cargo[cargoIndex].hsCodeId.text : '')
                    }
                    dataSource={hsCodes}
                    onUpdateInput={onChangeAutoCompleteHSCode}
                    onNewRequest={onChooseAutoCompleteHSCode}
                    dataSourceConfig={hsCodesConfig}
                    filter={AutoComplete.noFilter}
                    listStyle={{ overflow: 'auto', maxHeight: '300px', width: 'auto' }}
                    menuStyle={{ width: 'auto' }}
                    popoverProps={{
                        canAutoPosition: true,
                    }}
                    fullWidth
                />
            </div>
        </div>
    );
}

HSCode.propTypes = {
    cargoOrder: PropTypes.any,
    changeCargo: PropTypes.func,
};

HSCode.defaultProps = {
    cargoOrder: undefined,
    changeCargo: undefined,
};

export default React.memo(connect(
    (state, ownProps) => {
        const cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];
        return {
            cargoOrder,
        };
    }, 
    null,
)(HSCode));



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/HSIdsCodes/HSCode.jsx